export default "__VITE_ASSET__BketJKwv__"